import angular from 'angular';

import { DatepickerController } from './datepicker.controller';
import './datepicker.styles.scss';

export const Datepicker = {
  selector: 'abDatepicker',
  controller: DatepickerController,
  bindings: {
    selectedDate: '=',
    selectedDateChange: '&',
    returnType: '@?',
    maxDays: '@?',
    required: '=?',
    placeholder: '@?',
  },
  /* html */
  template: `
    <div class='ab-datepicker input-wrap date' ng-class="{'filled': $ctrl.selectedDate}">
      <input type="text" ng-model="$ctrl.labels.date" ng-focus="$ctrl.showDatepicker($event)" ng-required="$ctrl.required"
        placeholder="{{$ctrl.placeholder}}" onkeypress="return false;" id="datePicker">
      <label for="datePicker"><span>{{$ctrl.placeholder}}</span></label>

      <div class="fixed-wrap" ng-if="$ctrl.datepickerVisibility" ng-click="$ctrl.hideDatepicker()"></div>

      <div class="btn-wrap">
        <button type="button" class="btn-lvl3 remove-button" ng-click="$ctrl.removeDate()" ng-show="$ctrl.selectedDate">
          <svg class="ab-icon"><use xlink:href="#btn-delete"></use></svg>
        </button>
      </div>
    </div>
  `,
};

export default angular.module('directives.abDatepicker', [])
  .component(Datepicker.selector, Datepicker)
  .name;
